import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  groups: [],
};

const groupSlice = createSlice({
  name: "group",
  initialState,
  reducers: {
    setGroups: (state, action) => {
      state.groups = action.payload.groups;
    },
    addGroup: (state, action) => {
      state.groups.push(action.payload.group);
    },
    updateGroup: (state, action) => {
      const { group } = action.payload;
      const index = state.groups.findIndex(g => g?._id === group?._id);
      if (index !== -1) {
        state.groups[index] = group; 
      }
    },
    removeGroup: (state, action) => {
      const { groupId } = action.payload;
      state.groups = state.groups.filter(group => group._id !== groupId);
    },
    resetGroup: () => initialState,
  },
});

export const { setGroups, addGroup, updateGroup, removeGroup, resetGroup } = groupSlice.actions;
export default groupSlice.reducer;
